/* ==========================================================
   uhren4you – Produktbilder (ersetzt Magic Zoom)
   - Desktop: Bild überfahren = Lupe im kompletten Bildrahmen, Miniatur überfahren = Bild wechseln
   - Klick / Tippen = eigene Vollbild-Ansicht:
       Pfeile, Tastatur (← → Esc), Wischen, Miniaturen,
       Klick/Doppeltipp = Zoom, Ziehen = verschieben, Zwei-Finger-Zoom auf dem Handy
   Arbeitet mit der normalen Theme-Galerie (snippets/product-media-gallery.liquid).
   Texte kommen mehrsprachig aus window.u4yGalleryText (snippets/u4y-t.liquid).
   v2 (30.10.2026): Lupe ohne Überblenden und ohne Hängenbleiben, frei an den Pfeil-Rändern;
   Miniaturen wechseln das Bild nicht mehr, wenn die Seite nur unter der Maus durchscrollt.
   ========================================================== */
(function () {
  'use strict';
  if (window.u4yGalleryLoaded) return;
  window.u4yGalleryLoaded = true;

  var T = window.u4yGalleryText || {};
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var ZOOM = 2.5;
  var EDGE = 76; /* px links und rechts im Bildrahmen bleiben für die Pfeile frei (keine Lupe) */
  var INTENT = 140; /* ms über dem Bild, bevor die Lupe startet (nicht beim bloßen Drüberfahren) */
  var lastScroll = 0;

  window.addEventListener(
    'scroll',
    function () {
      lastScroll = Date.now();
    },
    { passive: true, capture: true }
  );

  function largestSrc(img) {
    if (!img) return '';
    var best = img.currentSrc || img.src;
    var max = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var w = parseInt(bits[1], 10);
      if (bits[0] && w > max) {
        max = w;
        best = bits[0];
      }
    });
    return best;
  }

  function visibleImageItems(gallery) {
    return Array.prototype.filter.call(
      gallery.querySelectorAll('.product__media-list .product__media-item'),
      function (li) {
        return (
          li.querySelector('.media-type-image img, .product__media img') &&
          !li.classList.contains('product__media-item--full') &&
          li.offsetParent !== null
        );
      }
    );
  }

  function clamp01(v) {
    return Math.min(Math.max(v, 0), 1);
  }

  /* ---------------- Lupe im Hauptbild (Desktop) ----------------
     - nutzt den ganzen Bildrahmen, nicht nur die innere Bildfläche
     - startet erst nach kurzer Verweilzeit und nicht an den Rändern mit den Pfeilen
     - endet sofort beim Verlassen, beim Scrollen, beim Mausrad und beim Bildwechsel
     - schaltet hart um (kein Überblenden – sonst sieht man kurz zwei Bilder übereinander) */
  function bindHoverZoom(gallery) {
    var active = null;
    var pending = null;
    var timer = null;
    var px = 0;
    var py = 0;

    function canZoom() {
      return fine.matches && window.innerWidth >= 990;
    }
    function itemAt(target) {
      if (!target || !target.closest) return null;
      if (target.closest('.slider-buttons, .u4y-zoom-btn, .thumbnail-list')) return null;
      var li = target.closest('.product__media-list .product__media-item');
      if (!li || !gallery.contains(li) || li.classList.contains('product__media-item--full')) return null;
      if (!li.querySelector('.product__media img') || li.querySelector('.deferred-media, video, model-viewer, iframe')) return null;
      return li;
    }
    function inZone(li, x, y) {
      var r = li.getBoundingClientRect();
      return x > r.left + EDGE && x < r.right - EDGE && y > r.top && y < r.bottom;
    }
    function layerFor(li) {
      var layer = null;
      Array.prototype.forEach.call(li.children, function (c) {
        if (c.classList.contains('u4y-zoom-layer')) layer = c;
      });
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'u4y-zoom-layer';
        layer.setAttribute('aria-hidden', 'true');
        li.appendChild(layer);
      }
      if (!layer.dataset.src) {
        var src = largestSrc(li.querySelector('.product__media img'));
        if (src) {
          layer.dataset.src = src;
          layer.style.backgroundImage = 'url("' + src + '")';
        }
      }
      return layer;
    }
    function place(li, layer) {
      var img = li.querySelector('.product__media img');
      var r = li.getBoundingClientRect();
      var nw = (img && img.naturalWidth) || r.width;
      var nh = (img && img.naturalHeight) || r.height;
      var s = Math.min(r.width / nw, r.height / nh);
      var zw = nw * s * ZOOM;
      var zh = nh * s * ZOOM;
      /* Position innerhalb der Lupen-Fläche (ohne Pfeil-Ränder) auf das ganze Bild abbilden */
      var fx = clamp01((px - r.left - EDGE) / Math.max(r.width - 2 * EDGE, 1));
      var fy = clamp01((py - r.top) / Math.max(r.height, 1));
      layer.style.backgroundSize = Math.round(zw) + 'px ' + Math.round(zh) + 'px';
      layer.style.backgroundPosition = Math.round(-(fx * (zw - r.width))) + 'px ' + Math.round(-(fy * (zh - r.height))) + 'px';
    }
    function cancel() {
      clearTimeout(timer);
      timer = null;
      pending = null;
    }
    function stop() {
      cancel();
      if (active) {
        active.li.classList.remove('u4y-zooming');
        active = null;
      }
    }
    function start(li) {
      var layer = layerFor(li);
      place(li, layer);
      li.classList.add('u4y-zooming');
      active = { li: li, layer: layer };
    }

    gallery.addEventListener(
      'mousemove',
      function (e) {
        if (!canZoom()) {
          stop();
          return;
        }
        px = e.clientX;
        py = e.clientY;
        var li = itemAt(e.target);
        if (!li || !inZone(li, px, py)) {
          stop();
          return;
        }
        if (active && active.li === li) {
          place(li, active.layer);
          return;
        }
        if (active) stop();
        if (pending === li) return;
        /* Seite scrollt gerade unter der Maus durch: keine Lupe */
        if (Date.now() - lastScroll < 250) return;
        cancel();
        pending = li;
        timer = setTimeout(function () {
          timer = null;
          if (pending !== li) return;
          pending = null;
          if (!li.matches(':hover') || !inZone(li, px, py)) return;
          start(li);
        }, INTENT);
      },
      { passive: true }
    );
    gallery.addEventListener('mouseleave', stop);
    gallery.addEventListener('wheel', stop, { passive: true });
    gallery.addEventListener('mousedown', stop);
    window.addEventListener('scroll', stop, { passive: true, capture: true });
    window.addEventListener('blur', stop);
    document.addEventListener('visibilitychange', stop);
  }

  /* ---------------- Miniatur überfahren = Bild wechseln (Desktop) ----------------
     Nur bei echter Mausbewegung: scrollt die Seite unter der ruhenden Maus durch, bleibt das Bild.
     Wechselt nur das Bild – ohne den Klick des Themes, der die Seite zum Bildanfang hochscrollt
     (sonst springt die Seite beim Überfahren und die Miniaturen rutschen unter der Maus weg). */
  function showSlide(gallery, btn) {
    var item = btn.closest('[data-target]');
    var list = gallery.querySelector('slider-component[id^="GalleryViewer"] .product__media-list');
    var target = null;
    if (item && list) {
      Array.prototype.forEach.call(list.children, function (c) {
        if (c.dataset && c.dataset.mediaId === item.dataset.target) target = c;
      });
    }
    if (!target || target.offsetParent === null) {
      btn.click();
      return;
    }
    Array.prototype.forEach.call(list.children, function (c) {
      c.classList.toggle('is-active', c === target);
    });
    gallery.querySelectorAll('.thumbnail-list .thumbnail[aria-current]').forEach(function (b) {
      b.removeAttribute('aria-current');
    });
    btn.setAttribute('aria-current', 'true');
    var pad = parseFloat(getComputedStyle(list).scrollPaddingLeft) || 0;
    list.scrollTo({ left: Math.max(target.offsetLeft - pad, 0), behavior: 'smooth' });
  }

  function bindThumbHover(gallery) {
    var timer = null;
    var pending = null;
    gallery.addEventListener(
      'mousemove',
      function (e) {
        if (!fine.matches) return;
        var btn = e.target.closest('.thumbnail-list .thumbnail');
        if (!btn || btn.getAttribute('aria-current') === 'true') {
          if (!btn) {
            clearTimeout(timer);
            pending = null;
          }
          return;
        }
        if (pending === btn) return;
        if (Date.now() - lastScroll < 300) return;
        clearTimeout(timer);
        pending = btn;
        timer = setTimeout(function () {
          pending = null;
          if (btn.matches(':hover') && Date.now() - lastScroll >= 300) showSlide(gallery, btn);
        }, 120);
      },
      { passive: true }
    );
    gallery.addEventListener('mouseleave', function () {
      clearTimeout(timer);
      pending = null;
    });
  }

  /* ---------------- Vollbild-Ansicht ---------------- */
  var lb = null;

  function svg(path) {
    return (
      '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="' +
      path +
      '"/></svg>'
    );
  }

  function buildLightbox() {
    var el = document.createElement('div');
    el.className = 'u4y-lb';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<div class="u4y-lb__bar"><span class="u4y-lb__count" aria-live="polite"></span>' +
      '<button type="button" class="u4y-lb__btn u4y-lb__close" aria-label="' + (T.close || 'Close') + '">' + svg('M5 5l14 14M19 5L5 19') + '</button></div>' +
      '<div class="u4y-lb__stage"><img class="u4y-lb__img" alt="" draggable="false"></div>' +
      '<button type="button" class="u4y-lb__btn u4y-lb__nav u4y-lb__prev" aria-label="' + (T.prev || 'Previous') + '">' + svg('M15 5l-7 7 7 7') + '</button>' +
      '<button type="button" class="u4y-lb__btn u4y-lb__nav u4y-lb__next" aria-label="' + (T.next || 'Next') + '">' + svg('M9 5l7 7-7 7') + '</button>' +
      '<div class="u4y-lb__thumbs" role="list"></div>';
    document.body.appendChild(el);

    var state = { srcs: [], alts: [], index: 0, scale: 1, x: 0, y: 0, lastFocus: null };
    var stage = el.querySelector('.u4y-lb__stage');
    var img = el.querySelector('.u4y-lb__img');
    var count = el.querySelector('.u4y-lb__count');
    var thumbs = el.querySelector('.u4y-lb__thumbs');

    function apply(animate) {
      img.style.transition = animate ? 'transform .25s ease' : 'none';
      img.style.transform = 'translate(' + state.x + 'px,' + state.y + 'px) scale(' + state.scale + ')';
      el.classList.toggle('is-zoomed', state.scale > 1);
    }
    function clamp() {
      var r = stage.getBoundingClientRect();
      var maxX = ((state.scale - 1) * r.width) / 2;
      var maxY = ((state.scale - 1) * r.height) / 2;
      state.x = Math.min(Math.max(state.x, -maxX), maxX);
      state.y = Math.min(Math.max(state.y, -maxY), maxY);
    }
    function reset(animate) {
      state.scale = 1;
      state.x = 0;
      state.y = 0;
      apply(animate);
    }
    function zoomAt(clientX, clientY, scale) {
      var r = stage.getBoundingClientRect();
      var cx = clientX - (r.left + r.width / 2);
      var cy = clientY - (r.top + r.height / 2);
      state.x = -cx * (scale - 1);
      state.y = -cy * (scale - 1);
      state.scale = scale;
      clamp();
      apply(true);
    }
    function show(i) {
      var n = state.srcs.length;
      state.index = (i + n) % n;
      reset(false);
      img.src = state.srcs[state.index];
      img.alt = state.alts[state.index] || '';
      count.textContent = (T.image || 'Bild') + ' ' + (state.index + 1) + ' / ' + n;
      Array.prototype.forEach.call(thumbs.children, function (b, k) {
        b.setAttribute('aria-current', k === state.index ? 'true' : 'false');
      });
      var active = thumbs.children[state.index];
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center' });
      el.classList.toggle('is-single', n < 2);
    }
    function open(srcs, alts, thumbSrcs, index) {
      state.srcs = srcs;
      state.alts = alts;
      state.lastFocus = document.activeElement;
      thumbs.innerHTML = '';
      thumbSrcs.forEach(function (t, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'u4y-lb__thumb';
        b.setAttribute('aria-label', (T.image || 'Bild') + ' ' + (k + 1));
        b.innerHTML = '<img src="' + t + '" alt="" loading="lazy">';
        b.addEventListener('click', function () {
          show(k);
        });
        thumbs.appendChild(b);
      });
      el.removeAttribute('hidden');
      document.documentElement.classList.add('u4y-lb-open');
      show(index);
      el.querySelector('.u4y-lb__close').focus();
    }
    function close() {
      el.setAttribute('hidden', '');
      document.documentElement.classList.remove('u4y-lb-open');
      img.removeAttribute('src');
      if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
    }

    el.querySelector('.u4y-lb__close').addEventListener('click', close);
    el.querySelector('.u4y-lb__prev').addEventListener('click', function () { show(state.index - 1); });
    el.querySelector('.u4y-lb__next').addEventListener('click', function () { show(state.index + 1); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(state.index - 1);
      else if (e.key === 'ArrowRight') show(state.index + 1);
      else if (e.key === 'Tab') {
        var f = el.querySelectorAll('button');
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });

    /* Maus: Klick = Zoom an dieser Stelle / zurück, Ziehen = verschieben */
    var drag = null;
    var moved = false;
    stage.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      moved = false;
      drag = { x: e.clientX, y: e.clientY, sx: state.x, sy: state.y };
    });
    window.addEventListener('mousemove', function (e) {
      if (!drag || el.hasAttribute('hidden')) return;
      var dx = e.clientX - drag.x;
      var dy = e.clientY - drag.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) moved = true;
      if (state.scale > 1 && moved) {
        state.x = drag.sx + dx;
        state.y = drag.sy + dy;
        clamp();
        apply(false);
      }
    });
    window.addEventListener('mouseup', function (e) {
      if (!drag) return;
      var wasDrag = moved;
      var dx = e.clientX - drag.x;
      drag = null;
      if (el.hasAttribute('hidden')) return;
      if (state.scale === 1 && wasDrag && Math.abs(dx) > 60) {
        show(state.index + (dx < 0 ? 1 : -1));
        return;
      }
      if (!wasDrag && e.target.closest('.u4y-lb__stage')) {
        if (state.scale > 1) reset(true);
        else zoomAt(e.clientX, e.clientY, ZOOM);
      }
    });
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var s = Math.min(Math.max(state.scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), 1), 4);
      if (s === 1) reset(true);
      else zoomAt(e.clientX, e.clientY, s);
    }, { passive: false });

    /* Touch: Wischen, Doppeltipp-Zoom, Zwei-Finger-Zoom, Verschieben */
    var t = null;
    var lastTap = 0;
    function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        t = { pinch: dist(e.touches[0], e.touches[1]), scale: state.scale };
      } else if (e.touches.length === 1) {
        var p = e.touches[0];
        t = { x: p.clientX, y: p.clientY, sx: state.x, sy: state.y, moved: false };
      }
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (!t) return;
      if (e.touches.length === 2 && t.pinch) {
        e.preventDefault();
        state.scale = Math.min(Math.max(t.scale * (dist(e.touches[0], e.touches[1]) / t.pinch), 1), 4);
        clamp();
        apply(false);
      } else if (e.touches.length === 1 && t.x !== undefined) {
        var p = e.touches[0];
        var dx = p.clientX - t.x;
        var dy = p.clientY - t.y;
        if (Math.abs(dx) + Math.abs(dy) > 6) t.moved = true;
        if (state.scale > 1) {
          e.preventDefault();
          state.x = t.sx + dx;
          state.y = t.sy + dy;
          clamp();
          apply(false);
        }
      }
    }, { passive: false });
    stage.addEventListener('touchend', function (e) {
      if (!t) return;
      var p = e.changedTouches[0];
      if (t.pinch) {
        if (state.scale < 1.05) reset(true);
        t = null;
        return;
      }
      var dx = p.clientX - t.x;
      if (state.scale === 1 && t.moved && Math.abs(dx) > 50) {
        show(state.index + (dx < 0 ? 1 : -1));
      } else if (!t.moved) {
        var now = Date.now();
        if (now - lastTap < 300) {
          if (state.scale > 1) reset(true);
          else zoomAt(p.clientX, p.clientY, ZOOM);
          lastTap = 0;
        } else {
          lastTap = now;
        }
      }
      t = null;
    });

    return { open: open, close: close };
  }

  function openFromGallery(gallery, clickedItem) {
    var items = visibleImageItems(gallery);
    if (!items.length) return false;
    var srcs = [];
    var alts = [];
    var thumbsSrc = [];
    items.forEach(function (li) {
      var im = li.querySelector('.product__media img');
      srcs.push(largestSrc(im));
      alts.push(im.getAttribute('alt') || '');
      thumbsSrc.push(im.currentSrc || im.src);
    });
    var index = Math.max(items.indexOf(clickedItem), 0);
    lb = lb || buildLightbox();
    lb.open(srcs, alts, thumbsSrc, index);
    return true;
  }

  function bindLightbox(gallery) {
    gallery.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('.slider-buttons')) return;
        var trigger = e.target.closest('.product__media-toggle, .product__modal-opener--image, .u4y-zoom-layer');
        if (!trigger || !gallery.contains(trigger)) return;
        var li = trigger.closest('.product__media-item');
        if (!li || li.classList.contains('product__media-item--full')) return;
        if (openFromGallery(gallery, li)) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function addHint(gallery) {
    if (gallery.querySelector('.u4y-zoom-hint')) return;
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
    if (!viewer) return;
    var hint = document.createElement('p');
    hint.className = 'u4y-zoom-hint';
    hint.innerHTML =
      svg('M11 4a7 7 0 1 1 0 14 7 7 0 0 1 0-14zM20 20l-4-4M11 8v6M8 11h6') +
      '<span class="u4y-zoom-hint__fine">' + (T.hint || '') + '</span>' +
      '<span class="u4y-zoom-hint__touch">' + (T.hintTouch || '') + '</span>';
    viewer.insertAdjacentElement('afterend', hint);
  }

  function init(gallery) {
    if (gallery.dataset.u4yGallery) return;
    gallery.dataset.u4yGallery = '1';
    gallery.classList.add('u4y-gallery');
    bindHoverZoom(gallery);
    bindThumbHover(gallery);
    bindLightbox(gallery);
    addHint(gallery);
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  /* Variantenwechsel / Schnellansicht laden die Galerie neu */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      initAll();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
